var exports = {
  "s": "CharacterCountAnnouncer.module__srOnly___S0tmcW",
};

module.exports = exports;
